<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <v-list>
                    <v-list-item>
                        <v-btn :disabled="hasValidWorkSession || workSessionIsLoading" block color="green" class="white--text" @click.prevent="start()">{{$vuetify.lang.t('$vuetify.start_stop_screen.start_work_btn')}}</v-btn>
                    </v-list-item>
                    <v-list-item>
                        <v-btn :disabled="!hasValidWorkSession || workSessionIsLoading" block color="red" class="white--text" @click.prevent="stop()">{{$vuetify.lang.t('$vuetify.start_stop_screen.stop_work_btn')}}</v-btn>
                    </v-list-item>
                </v-list>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import { mobileCheckMixin} from "../../../mixins/MobileCheckMixin/MobileCheckMixin";
    import LMRAVCChildComponentMixin  from "@/mixins/LMRAViewComponent/LmraViewComponentChildComponentMixin";
    //import {LocalTimeRegistrationHelper} from "../../../helpers/timeRegistration/LocalTimeRegistrationHelper";

    /*import appSettings from "../../../mixins/config/appSettings";*/

    import {startWorkEvent, stopWorkEvent/*, startedNormal, startedStaticThreeState*/} from "../../../store";
    import workSessionMixin from "@/workSessions/mixins/workSessionMixin"; //,

    export default {
        name: "LmraStartStopComponent",
        data : () =>{
          return {
              enable_start : false,
              enable_stop : false,
          }
        },
        methods:{
            start(){
                //TODO WHEN START PRESSED IT FETCHES DEFAULT DYNAMIC QUESTIONS ALSO MOVE ONE UP ?
                //CURRENTLY IN TEST PHASE BUT DOESN'T SEEM TO BE NEEDED

                //MOVE THIS ....
                /*if(appSettings.data().appSettings.usesStaticThreeStateLmra){
                   this.$store.commit('setUserStartEventType', startedStaticThreeState)
                }else{
                    this.$store.commit('setUserStartEventType', startedNormal);
                }*/
                this.$store.commit('setUserStartStopEvent', startWorkEvent);
                this.emitCloseCurrentComponent();
            },
            stop(){
                //this.$store.commit('setUserStartEventType', false);
                this.$store.commit('setUserStartStopEvent', stopWorkEvent);
                this.emitCloseCurrentComponent();
            }
        },
        mixins:[mobileCheckMixin, LMRAVCChildComponentMixin, workSessionMixin],
        created() {
          //TODO CHANGE !!!!
              /*  let has_session = LocalTimeRegistrationHelper.getWorkStateStartLockStateForUser(this.$store.getters.getUserId);
                this.enable_start = !has_session;
                this.enable_stop = has_session;*/
        }
    }
</script>

<style scoped>
</style>